import type { PromotionType } from '../models/promotions';

const PD_ALLOWED_VARIANT = 'variant_a';

/**
 * PD promos are gated by the topaz pricing experiment. Allow PD only when the
 * user is in control (falsy variant) or explicitly in `variant_a`. All other
 * truthy variants (e.g. `variant_b`, `variant_c`) suppress PD on the client.
 */
export function isPersonalizedDiscountAllowed(promotionType: PromotionType, variant: string | undefined): boolean {
  if (promotionType !== 'personalized-discount') {
    return true;
  }
  return !variant || variant === PD_ALLOWED_VARIANT;
}
